// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDrf2J9fQhTrf_UMjRxxHaynjWoIgHMK0g",
  authDomain: "ac-remote-87b5d.firebaseapp.com",
  projectId: "ac-remote-87b5d",
  storageBucket: "ac-remote-87b5d.firebasestorage.app",
  messagingSenderId: "133310530556",
  appId: "1:133310530556:web:4a2e09f2c362931c12e879"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export default app;